import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';
import { TextStyle } from 'styles/variables/mixins';
import { Breakpoints } from 'styles/variables/breakpoints';

const { white } = Colors;
const { sm } = Breakpoints;

export const CompletedText = styled.p`
    ${TextStyle({ fontSize: '30px', fontWeight: '500' })}
    text-align: center;
    @media screen and (max-width: 575px) {
        ${TextStyle({ fontSize: '25px', fontWeight: '500' })}
    }
    @media screen and (max-width: ${sm}) {
        ${TextStyle({ fontSize: '28px', fontWeight: '500' })}
    }
`;

export const GreenText = styled.span`
    color: #00c313;
`;

export const HoldTightGif = styled.img`
    border-radius: 4px;
    margin-bottom: 0.3rem;
`;

export const ModalWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 550px;
    &:focus-visible {
        outline: none;
    }
    @media screen and (max-width: 575px) {
        width: 300px;
    }
    @media screen and (max-width: ${sm}) {
        width: 400px;
    }
`;

export const Modal = styled.div`
    position: relative;
    width: 100%;
    background: ${white};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    gap: 1.2rem;
    flex-direction: column;
    padding: 2rem 4rem;
    &:focus-visible {
        outline: none;
    }
    padding: 1.8rem 2rem;
    @media screen and (max-width: 575px) {
        padding: 1.8rem 2rem;
        gap: 0.8rem;
    }
    @media screen and (max-width: ${sm}) {
        gap: 1rem;
    }
`;

export const ProgressBar = styled.div<{ width: string }>`
    height: 100%;
    width: ${({ width }) => (width ? width : '60%')};
    background: linear-gradient(to right, #5297ff, #5297ff 50%, white);
    border-radius: 50px;
`;

export const ProgressBarContainer = styled.div`
    height: 20px;
    width: '100%';
    background: linear-gradient(to right, ${white}, ${white} 1%, #576f95);
    border-radius: 50px;
`;

export const Prompt = styled.p`
    ${TextStyle({ fontSize: '24px', fontWeight: '700' })}
    text-align: center;
    text-transform: capitalize;
    line-height: 1.2;
    @media screen and (max-width: 575px) {
        ${TextStyle({ fontSize: '20px', fontWeight: '700' })}
    }
    @media screen and (max-width: ${sm}) {
        ${TextStyle({ fontSize: '21px', fontWeight: '700' })}
    }
`;
